export default __webpack_public_path__ + "static/cert-8-30afca8c3004cdcd0c44adc7f234ecc6.png";